// @ts-nocheck
import { BlockProps } from "@store/Library/Components/Toolkit/Block";
import { GridContainerProps } from "@insite/mobius/GridContainer";
import { GridItemProps } from "@insite/mobius/GridItem";
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import { ButtonPresentationProps } from "@insite/mobius/Button";
import { InfosBoxProps } from "@store/Library/Components/Toolkit/InfosBox";
import { ModalPresentationProps } from "@insite/mobius/Modal";
import { LoadingOverlayProps } from "@store/MobiusOverrides/LoadingOverlay/LoadingOverlay";
import { css } from "styled-components";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import getColor from "@insite/mobius/utilities/getColor";
import breakpoint from "@toolkit/Framework/Common/Utilities/breakpoint";
import { FormActionsProps } from "@store/Library/Components/Toolkit/FormActions";

export interface ConfigurationFormProps {
    block?: BlockProps;
    container?: GridContainerProps;
    formContainer?: GridContainerProps;
    fieldItem?: GridItemProps;
    smallerFieldItem?: GridItemProps;
    fullWidthItem?: GridItemProps;
    actionItem?: GridItemProps;
    titleText?: TypographyPresentationProps;
    sectionText?: TypographyPresentationProps;
    introText?: TypographyPresentationProps;
    questionnaireText?: TypographyPresentationProps;
    clearButton?: ButtonPresentationProps;
    submitButton?: ButtonPresentationProps;
    successInfosBox?: InfosBoxProps;
    successModal?: ModalPresentationProps;
    continueButton?: ButtonPresentationProps;
    errorInfosBox?: InfosBoxProps;
    loadingOverlay?: LoadingOverlayProps;
    formActions?: FormActionsProps;
}

export const configurationFormProps: ConfigurationFormProps = {
    block: {
        wrapperCss: css`
            max-width: ${pxToRem(995)};
            margin: 0 auto;
        `,
    },
    container: {
        gap: 32,
    },
    formContainer: {
        gap: 32,
        css: css`
            border: 1px solid ${getColor("common.border")};
            border-radius: ${pxToRem(10)};
            padding: ${pxToRem(24)};
        `,
    },
    fieldItem: {
        width: [12, 6, 6, 6, 6],
    },
    smallerFieldItem: {
        width: [12, 6, 6, 4, 4],
    },
    fullWidthItem: {
        width: 12,
    },
    actionItem: {
        width: 12,
        css: css`
            display: flex;
            justify-content: flex-end;
        `,
    },
    titleText: {
        variant: "h2",
    },
    sectionText: {
        variant: "h6",
        forwardAs: "h3",
    },
    introText: {
        variant: "p",
    },
    questionnaireText: {
        variant: "p",
    },
    clearButton: {
        variant: "tertiary",
    },
    submitButton: {
        variant: "primary",
    },
    successInfosBox: { type: "success" },
    successModal: { sizeVariant: "small" },
    continueButton: { variant: "primary" },
    errorInfosBox: { type: "error" },
    loadingOverlay: { minHeight: 200 },
    formActions: {
        extendedStyles: {
            flexWrapper: {
                wrapper: {
                    css: css`
                        ${breakpoint("xs", "down")} {
                            width: 100%;
                        }
                    `,
                },
            },
        },
    },
};
